import { RecurringModel, RecurringsModel } from 'src/models/RecurringModel';
import { Reducer } from 'redux';
import { RESET_RECURRING, UPDATE_RECURRING } from 'src/redux/actions/recurringActions';

export type RecurringsState = RecurringsModel;

const DEFAULT = {} as RecurringsState;

const recurringReducer: Reducer<RecurringsState> = (state = DEFAULT, action) => {
  switch (action.type) {
    case UPDATE_RECURRING: {
      const { id, recurring } = action.payload;
      return { ...state, [id]: { ...recurring as RecurringModel } };
    }
    case RESET_RECURRING: {
      const { recurringId } = action.payload;
      const { [recurringId]: removedRecurring, ...remainingRecurrings } = state;
      return { ...remainingRecurrings };
    }
    default:
      return state;
  }
};

export default recurringReducer;
